import { Option } from '../../../../../components/dropdown/Dropdown';

type State = {
	selectedReason: Option;
	description: string;
};

type Action =
	| { type: 'SET_SELECTED_OPTION'; option: Option }
	| { type: 'SET_DESCRIPTION_VALUE'; value: string };

export const deleteAccountInitialState = {
	selectedReason: { value: '', label: '' },
	description: '',
};

export const deleteAccountReducer = (state: State, action: Action) => {
	switch (action.type) {
		case 'SET_SELECTED_OPTION':
			return {
				...state,
				selectedReason: action.option,
			};
		case 'SET_DESCRIPTION_VALUE':
			return {
				...state,
				description: action.value,
			};
		default:
			return state;
	}
};
